<!-- <nz-card nzTitle="User Profile"> -->
  <!-- Basic Info Section -->
  <nz-card nzType="inner" nzTitle="Basic Info">
    <form [formGroup]="profileform">
     <div class="ant-row ant-row-space-between ant-row-middle" style="margin-bottom: 24px">
       <div class="ant-col">
         <nz-avatar [nzSrc]="logoUrl" [nzSize]="96"></nz-avatar>
       </div>
       <div class="ant-col" style="flex: 1; padding-left: 24px">
        <h2 style="margin: 0 0 8px 0">{{ USER_NAME }}</h2>
         <div class="text-muted" style="margin-bottom: 8px">
           <!-- ID: 22 <i nz-icon nzType="copy" nzTheme="outline" style="margin-left: 8px; cursor: pointer;"></i> -->
         </div>
         <button nz-button nzType="default" (click)="showModal()">
           <i nz-icon nzType="lock" style="margin-right: 4px;"></i> Change Password
         </button>
       </div>
     </div>
 
     <!-- Form Fields -->
   <nz-row [nzGutter]="10">
 
 
  <div nz-col [nzSpan]="12" class="form-section"   >
       <nz-form-item>
         <nz-form-label nz-col [nzSpan]="6" nzFor="userName" nzLabelAlign="left" >User Name:  <span style="color: red;"> * </span></nz-form-label>
         <nz-form-control nz-col nzSpan="16" nzHasFeedback nzErrorTip="Please enter website URL">
       <input nz-input formControlName="userName"  readonly />
         </nz-form-control>
       </nz-form-item>
     </div>
 
      <div nz-col [nzSpan]="12" class="form-section"   >
       <nz-form-item>
         <nz-form-label nz-col [nzSpan]="6" nzFor="officialWebsite" nzLabelAlign="left" >Role  <span style="color: red;"> * </span></nz-form-label>
         <nz-form-control nz-col nzSpan="16" nzHasFeedback nzErrorTip="Please enter website URL">
           <input id="officialWebsite" nz-input formControlName="role" placeholder="Role"  readonly/>
         </nz-form-control>
       </nz-form-item>
     </div>
  <div nz-col [nzSpan]="12" class="form-section"   >
       <nz-form-item>
         <nz-form-label nz-col [nzSpan]="6" nzFor="email" nzLabelAlign="left" >Email Id  <span style="color: red;"> * </span></nz-form-label>
         <nz-form-control nz-col nzSpan="16" nzHasFeedback nzErrorTip="Please enter EmailId">
           <input id="email" nz-input formControlName="email" placeholder="Email ID" readonly/>
         </nz-form-control>
       </nz-form-item>
     </div>
       <div nz-col [nzSpan]="12" class="form-section"   >
       <nz-form-item>
         <nz-form-label nz-col [nzSpan]="6" nzFor="billingtype" nzLabelAlign="left" >Billing Type  <span style="color: red;"> * </span></nz-form-label>
         <nz-form-control nz-col nzSpan="16" nzHasFeedback nzErrorTip="Please enter Billing type">
           <input id="billingtype" nz-input formControlName="billingtype" placeholder="Billing Type" readonly />
         </nz-form-control>
       </nz-form-item>
     </div>
 
 
     <nz-modal [(nzVisible)]="isVisible" nzTitle="Change Your Password"  [nzMaskClosable]="false" [nzKeyboard]="false" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
       <ng-container *nzModalContent>
          <nz-row [nzGutter]="16">

      <!-- <div nz-col [nzSpan]="20" class="form-section"   >
       <nz-form-item>
         <nz-form-label nz-col [nzSpan]="8" nzFor="oldpassword" nzLabelAlign="left" >Current Password:  <span style="color: red;"> * </span></nz-form-label>
         <nz-form-control nz-col nzSpan="16" nzHasFeedback nzErrorTip="Old Password">
       <input nz-input type="password" formControlName="oldPassword" readonly class="current-password"/>
         </nz-form-control>
       </nz-form-item>
     </div>
     -->

     <div nz-col [nzSpan]="20" class="form-section">
      <nz-form-item>
        <nz-form-label
          nz-col
          [nzSpan]="8"
          nzFor="oldpassword"
          nzLabelAlign="left"
        >
          Current Password:
          <span style="color: red;">*</span>
        </nz-form-label>

        <nz-form-control
          nz-col
          nzSpan="16"
          nzHasFeedback
          nzErrorTip="Old Password"
        >
          <nz-input-group
            [nzSuffix]="passwordEyeIcon"
          >
            <input
              nz-input
              [type]="showOldPassword ? 'text' : 'password'"
              formControlName="oldPassword"
              readonly
              class="current-password"
            />
          </nz-input-group>

          <ng-template #passwordEyeIcon>
            <span
              nz-icon
              [nzType]="showOldPassword ? 'eye-invisible' : 'eye'"
              (click)="showOldPassword = !showOldPassword"
              style="cursor: pointer;"
            ></span>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>

      <!-- <div nz-col [nzSpan]="20" class="form-section"   >
       <nz-form-item>
         <nz-form-label nz-col [nzSpan]="7" nzFor="officialWebsite" nzLabelAlign="left" >New Password:  <span style="color: red;"> * </span></nz-form-label>
         <nz-form-control nz-col nzSpan="16" nzHasFeedback nzErrorTip="New Password">
           <input id="newPassword" nz-input formControlName="newPassword" placeholder="New Password" class="new-password"/>
         </nz-form-control>
       </nz-form-item>
     </div> -->
     <div nz-col [nzSpan]="20" class="form-section">
  <nz-form-item>
    <nz-form-label
      nz-col
      [nzSpan]="8"
      nzFor="newPassword"
      nzLabelAlign="left"
    >
      New Password:
      <span style="color: red;">*</span>
    </nz-form-label>

    <nz-form-control nz-col nzSpan="16" nzErrorTip="New Password">
      <nz-input-group [nzSuffix]="newPasswordEyeIcon">
        <input
          id="newPassword"
          nz-input
          [type]="showNewPassword ? 'text' : 'password'"
          formControlName="newPassword"
          placeholder="New Password"
          class="new-password"
          (focus)="showPasswordRules=true"
          (blur)="showPasswordRules=false"
        />
      </nz-input-group>

      <ng-template #newPasswordEyeIcon>
        <span
          nz-icon
          [nzType]="showNewPassword ? 'eye-invisible' : 'eye'"
          (click)="showNewPassword = !showNewPassword"
          style="cursor: pointer;"
        ></span>
      </ng-template>
    </nz-form-control>
  </nz-form-item>
</div>

    <div
      *ngIf="showPasswordRules"
      class="password-rules"
    >

      <p><b>PASSWORD MUST CONTAIN</b></p>

      <div [style.color]="hasMinLength ? 'green' : '#666'">
        <span>{{hasMinLength ? '✔' : '○'}}</span>
        At least 8 characters
      </div>

      <div [style.color]="hasUpperCase ? 'green' : '#666'">
        <span>{{hasUpperCase ? '✔' : '○'}}</span>
        One uppercase letter (A-Z)
      </div>

      <div [style.color]="hasLowerCase ? 'green' : '#666'">
        <span>{{hasLowerCase ? '✔' : '○'}}</span>
        One lowercase letter (a-z)
      </div>

      <div [style.color]="hasNumber ? 'green' : '#666'">
        <span>{{hasNumber ? '✔' : '○'}}</span>
        One number (0-9)
      </div>

      <div [style.color]="hasSpecialChar ? 'green' : '#666'">
        <span>{{hasSpecialChar ? '✔' : '○'}}</span>
        One special character (!@#$...)
      </div>

    </div>

  <!-- Confirm New Password -->
  <div nz-col [nzSpan]="20" class="form-section">
  <nz-form-item>
    <nz-form-label
      nz-col
      [nzSpan]="8"
      nzFor="confirmPassword"
      nzLabelAlign="left"
    >
      Confirm Password:
      <span style="color: red;">*</span>
    </nz-form-label>

    <nz-form-control
      nz-col
      nzSpan="16"
      nzErrorTip="Confirm Password"
    >
      <nz-input-group [nzSuffix]="confirmPasswordEyeIcon">
        <input
          id="confirmPassword"
          nz-input
          [type]="showConfirmPassword ? 'text' : 'password'"
          formControlName="confirmPassword"
          placeholder="Confirm Password"
          class="new-password"
        />
      </nz-input-group>

      <ng-template #confirmPasswordEyeIcon>
        <span
          nz-icon
          [nzType]="showConfirmPassword ? 'eye-invisible' : 'eye'"
          (click)="showConfirmPassword = !showConfirmPassword"
          style="cursor: pointer;"
        ></span>
      </ng-template>
    </nz-form-control>
  </nz-form-item>
</div>
      <div
        *ngIf="profileform.get('confirmPassword')?.value"
        style="margin-top:5px;"
      >

        <span
          *ngIf="passwordsMatch"
          style="color:green"
        >
          ✔ Passwords match.
        </span>

        <span
          *ngIf="!passwordsMatch"
          style="color:red"
        >
          ⚠ Passwords do not match.
        </span>

      </div>
      </nz-row>
     
       </ng-container>
     </nz-modal>
 
     </nz-row>
     </form>
   </nz-card>
 
 <!-- </nz-card> -->
 